/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agb_Data_Protection_LinkInputs */

const en_agb_data_protection_link = /** @type {(inputs: Agb_Data_Protection_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Privacy Policy`)
};

const de_agb_data_protection_link = /** @type {(inputs: Agb_Data_Protection_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datenschutzerklaerung`)
};

const fr_agb_data_protection_link = /** @type {(inputs: Agb_Data_Protection_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Politique de confidentialité`)
};

const es_agb_data_protection_link = /** @type {(inputs: Agb_Data_Protection_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Política de privacidad`)
};

const it_agb_data_protection_link = /** @type {(inputs: Agb_Data_Protection_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Informativa sulla privacy`)
};

const nl_agb_data_protection_link = /** @type {(inputs: Agb_Data_Protection_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Privacybeleid`)
};

const pl_agb_data_protection_link = /** @type {(inputs: Agb_Data_Protection_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Polityka prywatności`)
};

const fi_agb_data_protection_link = /** @type {(inputs: Agb_Data_Protection_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tietosuojakäytäntö`)
};

const da_agb_data_protection_link = /** @type {(inputs: Agb_Data_Protection_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Privatlivspolitik`)
};

const sv_agb_data_protection_link = /** @type {(inputs: Agb_Data_Protection_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Integritetspolicy`)
};

/**
* | output |
* | --- |
* | "Privacy Policy" |
*
* @param {Agb_Data_Protection_LinkInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const agb_data_protection_link = /** @type {((inputs?: Agb_Data_Protection_LinkInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agb_Data_Protection_LinkInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_agb_data_protection_link(inputs)
	if (locale === "fr") return fr_agb_data_protection_link(inputs)
	if (locale === "es") return es_agb_data_protection_link(inputs)
	if (locale === "it") return it_agb_data_protection_link(inputs)
	if (locale === "nl") return nl_agb_data_protection_link(inputs)
	if (locale === "pl") return pl_agb_data_protection_link(inputs)
	if (locale === "fi") return fi_agb_data_protection_link(inputs)
	if (locale === "da") return da_agb_data_protection_link(inputs)
	if (locale === "sv") return sv_agb_data_protection_link(inputs)
	return en_agb_data_protection_link(inputs)
});